import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getUnAppliedLeaves = async ({
  companyCode,
  locationCode,
  fromDate,
  toDate,
  departmentCode = 0,
  employeeCode = 0,
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  if (companyCode && locationCode) {
    let url = isAllCompanies
      ? `${Api_EndPoints.AllCompanies_GetUnAppliedLeaveEmployees}`
      : `${Api_EndPoints.GetUnAppliedLeaveEmployees}`;

    let queryString = `?CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}&FromDate=${fromDate}&ToDate=${toDate}`;

    if (departmentCode !== 0) {
      queryString += `&DepartmentCode=${departmentCode}`;
    }

    if (employeeCode !== 0) {
      queryString += `&EmployeeCode=${employeeCode}`;
    }

    if (isAllCompanies && userId !== 0) {
      queryString += `&UserId=${userId}`;
    }

    const { data } = await http_payroll.get(`${url}${queryString}`);
    return data;
  }

  return [];
};

export const useGetUnAppliedLeave = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetUnAppliedLeaveEmployees
        : Api_EndPoints.GetUnAppliedLeaveEmployees,
      input,
    ],
    queryFn: () => getUnAppliedLeaves(input),
    refetchOnWindowFocus: false,
  });
};
